<button (click)="goBack()"
    class="group flex items-center justify-center w-9 h-9 rounded-full bg-white border border-slate-200 text-primary shadow-sm hover:bg-primary hover:text-white hover:border-primary transition-all duration-200 mr-4 focus:outline-none focus:ring-2 focus:ring-primary/20 cursor-pointer"
    [attr.title]="label" type="button" aria-label="{{ label }}">
    <i class="fas fa-arrow-left text-[14px]"></i>
</button>